<template lang="pug">
v-app(:class="classes", ref="app")
  page-transition
    router-view
</template>
<script>
import axios from 'axios';
import PageTransition from './components/ui/PageTransition';

axios.defaults.withCredentials = true;

export default {
  name: 'App',
  components: {
    PageTransition,
  },
  computed: {
    classes() {
      const classObject = {};
      if (this.$route.name) {
        classObject[this.$route.name] = true;
      }
      return classObject;
    },
  },
};
</script>
